import { SeguridadService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const SeguridadManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listarLogsAuditoria = (where) => {
    return SeguridadService.listarLogsAuditoria(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const exportarLogsAuditoria = (where) => {
    return SeguridadService.exportarLogsAuditoria(where).then((res) => res);
  };

  const buscarLogAuditoria = (idSec) => {
    return SeguridadService.buscarLogAuditoria({ idSec }).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  return { listarLogsAuditoria, exportarLogsAuditoria, buscarLogAuditoria };
})();
